import React from "react";
import {
    Box,
    Skeleton,
    Text,
} from "@chakra-ui/react";
import Chart from "react-apexcharts";

const TopPerformingAgentsChart = ({
    data = [],
    isLoading,
}) => {
    const agents = data.map(
        (agent) =>
            agent.agent_name ||
            agent.agent_number ||
            "Unknown Agent"
    );

    const revenue = data.map(
        (agent) => agent.revenue ?? 0
    );

    const options = {
        chart: {
            type: "bar",
            toolbar: {
                show: false,
            },
        },
        plotOptions: {
            bar: {
                horizontal: true,
                borderRadius: 4,
                barHeight: "55%",
            },
        },
        dataLabels: {
            enabled: true,
        },
        xaxis: {
            categories: agents,
            labels: {
                formatter: (value) =>
                    `P ${Number(value).toLocaleString()}`,
            },
        },
        grid: {
            strokeDashArray: 4,
        },
    };

    return (
        <Box
            bg="white"
            borderRadius="15px"
            p="24px"
            height="400px"
            width="100%"
            boxShadow="sm"
        >
            <Text
                color="#071D54"
                fontSize="lg"
                fontWeight="700"
                mb={4}
            >
                Top Performing Agents
            </Text>

            {isLoading ? (
                <Skeleton
                    height="300px"
                    borderRadius="12px"
                />
            ) : data.length === 0 ? (
                <Box
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    height="300px"
                >
                    <Text
                        color="gray.500"
                        fontSize="sm"
                    >
                        No top performing agents available.
                    </Text>
                </Box>
            ) : (
                <Chart
                    options={options}
                    series={[
                        {
                            name: "Revenue",
                            data: revenue,
                        },
                    ]}
                    type="bar"
                    height={300}
                />
            )}
        </Box>
    );
};

export default TopPerformingAgentsChart;